import { render, staticRenderFns } from "./OrdersFBATable.vue?vue&type=template&id=1aca3b56&scoped=true"
import script from "./OrdersFBATable.vue?vue&type=script&lang=js"
export * from "./OrdersFBATable.vue?vue&type=script&lang=js"
import style0 from "./OrdersFBATable.vue?vue&type=style&index=0&id=1aca3b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aca3b56",
  null
  
)

export default component.exports